module.exports = __webpack_public_path__ + "static/ec-orr-desktop-3b2febc895e922543a8dd76aabac32e4.png";